import { FC } from 'react';
import { WbCardContent } from '@agilelab/plugin-wb-platform';
import { Paper, makeStyles } from '@material-ui/core';
import { DeleteRolesDialog } from './DeleteRolesDialog';
import { RolesCardHeader, RolesTable } from './RolesTable';
import { RolesTableContextProvider } from './RolesTableContext';

const useStyles = makeStyles(
  theme => ({
    paper: {
      height: '100%',
    },
    container: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    flexBox: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
  }),
  { name: 'RolesTab' },
);

export const RolesTab: FC = () => {
  const classes = useStyles();
  return (
    <RolesTableContextProvider>
      <Paper className={classes.paper}>
        <WbCardContent className={classes.container}>
          <RolesCardHeader />
          <RolesTable />
        </WbCardContent>
      </Paper>
      <DeleteRolesDialog />
    </RolesTableContextProvider>
  );
};
